module.exports = __webpack_public_path__ + "static/hero-partner-7d59633481509c9b816f88c20730e0de.png";